import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { getInboxes, getCurrentInbox, getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import selectInbox from '../../unified-inbox/actions/selectInbox';
import SearchAndFilterModeButton from '../../thread-search-and-filtering/components/SearchAndFilterModeButton';
import InboxSelect from '../../unified-inbox/components/InboxSelect';
import { getShowAgentStatus } from '../../agentStatus/selectors/getShowAgentStatus';
import { getIsChatSetup } from '../../verify-install/selectors/getIsChatSetup';
import OutsideBusinessHours from '../../agentStatus/components/OutsideBusinessHours';
import { useCallingChannelInstances } from 'channel-settings/calling/public/hooks/useCallingChannelInstances';
import { AgentStatusContainer } from '../../agentStatus/containers/AgentStatusContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledHeader = styled.div.withConfig({
  displayName: "NavSidebarHeader__StyledHeader",
  componentId: "sc-144r4z8-0"
})(["display:flex;flex-direction:column;align-items:center;justify-content:space-between;width:100%;padding:4px 8px 12px 8px;border-bottom:1px solid ", ";"], GREAT_WHITE);
const StyledInboxSelectWrapper = styled.div.withConfig({
  displayName: "NavSidebarHeader__StyledInboxSelectWrapper",
  componentId: "sc-144r4z8-1"
})(["display:flex;flex-direction:row;align-items:center;justify-content:space-between;width:100%;padding-left:26px;"]);
const NavSidebarHeader = () => {
  const dispatch = useDispatch();
  const currentInbox = useSelector(getCurrentInbox);
  const currentInboxId = useSelector(getCurrentInboxId);
  const inboxes = useSelector(getInboxes);
  const isChatSetup = useSelector(getIsChatSetup);
  const showAgentStatus = useSelector(getShowAgentStatus);
  const {
    data
  } = useCallingChannelInstances();
  const onInboxSelected = useCallback(inbox => {
    dispatch(selectInbox(inbox));
  }, [dispatch]);
  const isCallingConnectedToInbox = useMemo(() => {
    if (data && data.results) {
      return data.results.find(channelInstance => channelInstance.inboxId === currentInboxId);
    }
    return false;
  }, [currentInboxId, data]);
  const shouldShowAvailabilityToggle = useMemo(() => {
    return showAgentStatus || isCallingConnectedToInbox;
  }, [isCallingConnectedToInbox, showAgentStatus]);
  return /*#__PURE__*/_jsxs(StyledHeader, {
    children: [/*#__PURE__*/_jsxs(StyledInboxSelectWrapper, {
      children: [currentInbox ? /*#__PURE__*/_jsx(InboxSelect, {
        onInboxSelect: onInboxSelected,
        inboxes: inboxes,
        currentInbox: currentInbox
      }) : null, /*#__PURE__*/_jsx(SearchAndFilterModeButton, {})]
    }), isChatSetup && /*#__PURE__*/_jsx(OutsideBusinessHours, {
      className: "p-bottom-5"
    }), shouldShowAvailabilityToggle && /*#__PURE__*/_jsx(AgentStatusContainer, {})]
  });
};
NavSidebarHeader.displayName = 'NavSidebarHeader';
export default NavSidebarHeader;